import clearIcon from '../../../../assets/svg/xStrokeIcon.svg';
import { FORM_FIELDS } from '../consts';
import { FEATURE_FLAG } from '../../../../constants/general';
import { ValidateFieldTypes, validationSchemeMap } from '../../../../helpers/inputUtils.helper';

export const billPayForm = () => [
  {
    type: 'single',
    inputType: 'text',
    name: 'Business Name',
    requiredMessage: 'Vendor name is required',
    validateScheme: /.{3,}/,
    validateErrorMessage: 'minimum 3 characters',
    inputId: FORM_FIELDS.BUSINESS_NAME,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    name: 'Email (Optional)',
    requiredMessage: '',
    validateScheme: validationSchemeMap[ValidateFieldTypes.EMAIL],
    validateErrorMessage: 'Email format is invalid',
    inputId: FORM_FIELDS.EMAIL,
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'checkbox',
    name: 'Notify vendor when payment was made',
    requiredMessage: '',
    inputId: FORM_FIELDS.NOTIFY_ON_PAYMENT,
    shouldValidateOnClick: true,
    featureFlagId: FEATURE_FLAG.NOTIFY_VENDOR,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 17,
    name: 'MANAGE_VENDOR.FORM.ACH_ACCOUNT',
    replaceValueScheme: /\D/g,
    requiredMessage: '',
    validateScheme: /^[0-9]{5,17}$/,
    validateErrorMessage: 'Please enter a valid ACH Account Number',
    inputId: FORM_FIELDS.ACH_ACCOUNT_NUMBER,
    specificType: 'number',
    shouldValidateOnClick: true,
  },
  {
    type: 'single',
    inputType: 'text',
    maxLen: 9,
    name: 'MANAGE_VENDOR.FORM.ACH_ROUTE',
    replaceValueScheme: /\D/g,
    requiredMessage: '',
    validateScheme: /^[0-9]{9}$/,
    validateErrorMessage: 'Please enter a valid ACH Routing Number',
    inputId: FORM_FIELDS.ACH_ROUTING_NUMBER,
    specificType: 'number',
    shouldValidateOnClick: true,
  },

  {
    type: 'trigger',
    triggerTitle: 'Address (Optional)',
    triggerId: 'ADDRESS_GROUP',
  },
  {
    type: 'single',
    inputType: 'text',
    linkedTriggerId: 'ADDRESS_GROUP',
    name: 'MANAGE_VENDOR.FORM.LINE_1',
    requiredMessage: '',
    validateScheme: /^[A-Za-z0-9-\s]+$/,
    validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ADDRESS.VALIDATE',
    inputId: FORM_FIELDS.LINE_ONE,
    shouldValidateOnClick: true,
    clearIcon: {
      Asset: clearIcon,
      styles: 'stroke-bw01 w-[50%] h-[50%] mx-auto my-auto',
    },
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        linkedTriggerId: 'ADDRESS_GROUP',
        maxLen: 20,
        name: 'MANAGE_VENDOR.FORM.LINE_2',
        requiredMessage: '',
        validateScheme: '',
        validateErrorMessage: '',
        inputId: FORM_FIELDS.LINE_TWO,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'text',
        linkedTriggerId: 'ADDRESS_GROUP',
        name: 'MANAGE_VENDOR.FORM.ZIP',
        replaceValueScheme: /\D/g,
        maxLen: 5,
        requiredMessage: '',
        validateScheme: /^[0-9]{5}$/,
        validateErrorMessage: 'SUPPLIER.MANAGE.FORM.ZIP.VALIDATE',
        inputId: FORM_FIELDS.ZIP_CODE,
        specificType: 'number',
        shouldValidateOnClick: true,
      },
    ],
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        linkedTriggerId: 'ADDRESS_GROUP',
        name: 'MANAGE_VENDOR.FORM.CITY',
        requiredMessage: '',
        validateScheme: /^[A-Za-z\s]+$/,
        validateErrorMessage: 'SUPPLIER.MANAGE.FORM.CITY.VALIDATE',
        inputId: FORM_FIELDS.CITY,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'select',
        linkedTriggerId: 'ADDRESS_GROUP',
        name: 'MANAGE_VENDOR.FORM.STATE',
        requiredMessage: '',
        defaultOption: 'MANAGE_VENDOR.FORM.STATE',
        inputId: FORM_FIELDS.STATE,
      },
    ],
  },
];
